document.addEventListener('DOMContentLoaded', () => {
  const buttons = document.querySelectorAll('.server_panels_btn')
  const dataWrapper = document.getElementById('panel-data')

  const fallback = {
    title: document.getElementById('panel-title'),
    description: document.getElementById('panel-description'),
    description2: document.getElementById('panel-description-2'),
    button: document.getElementById('panel-button'),
    buttonMobile: document.getElementById('panel-button-mobile'),
    funcList: document.querySelector('.server_manager_func_block_list'),
  }

  const sectionMap = {
    titles: {
      elements: document.querySelectorAll('.panel-title'),
      classPrefix: 'panel-title',
    },
    descriptions: {
      elements: document.querySelectorAll('.panel-description'),
      classPrefix: 'panel-description',
    },
    descriptions2: {
      elements: document.querySelectorAll('.panel-description-2'),
      classPrefix: 'panel-description-2',
    },
    possibilities: {
      elements: document.querySelectorAll('.server_manager_possibilities_block_list'),
      classPrefix: 'possibilities',
    },
    funcBlock: {
      elements: document.querySelectorAll('.func-block'),
      classPrefix: 'func-block',
    },
  }

  const getData = type => ({
    title: dataWrapper?.dataset?.[`${type}Title`] || '',
    description: dataWrapper?.dataset?.[`${type}Description`] || '',
    description2: dataWrapper?.dataset?.[`${type}Description2`] || '',
    funcLabels: safeJson(dataWrapper?.dataset?.[`${type}FuncLabels`]),
    funcValues: safeJson(dataWrapper?.dataset?.[`${type}FuncValues`]),
    button:
      type === 'ispmanager' && document.getElementById('greybutton-template')
        ? document.getElementById('greybutton-template').innerHTML
        : '',
  })

  const safeJson = str => {
    try {
      return JSON.parse(str || '[]')
    } catch {
      return []
    }
  }

  const switchPanel = type => {
    // toggle active class on buttons
    buttons.forEach(btn => btn.classList.remove('active'))
    const activeBtn = document.querySelector(`.server_panels_btn[data-type="${type}"]`)
    if (activeBtn) activeBtn.classList.add('active')

    // try to switch visible blocks if they exist
    let switched = false
    Object.values(sectionMap).forEach(({ elements }) => {
      if (elements.length) {
        switched = true
        elements.forEach(el => el.classList.remove('active'))
      }
    })

    Object.entries(sectionMap).forEach(([, { classPrefix }]) => {
      const el = document.querySelector(`.${classPrefix}--${type}`)
      if (el) el.classList.add('active')
    })

    document
      .querySelectorAll('#panel-button > div, #panel-button-mobile > div')
      .forEach(btn => {
        btn.classList.remove('active')
      })
    document.querySelectorAll(`.panel-button--${type}`).forEach(btn => {
      btn.classList.add('active')
    })

    // if blocks not found – fallback to dataset content
    if (!switched && dataWrapper && fallback.title) {
      const data = getData(type)
      fallback.title.textContent = data.title
      fallback.description.textContent = data.description
      fallback.description2.textContent = data.description2
      fallback.button.innerHTML = data.button
      fallback.buttonMobile.innerHTML = data.button

      const items = fallback.funcList?.querySelectorAll('li') || []
      data.funcLabels.forEach((label, i) => {
        const spans = items[i]?.querySelectorAll('span') || []
        if (spans[0]) spans[0].textContent = label || ''
        if (spans[1]) spans[1].textContent = data.funcValues[i] || ''
      })
    }
  }

  buttons.forEach(btn => {
    btn.addEventListener('click', () => {
      switchPanel(btn.dataset.type)
    })
  })

  switchPanel('cpanel')
})
